import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBluetooth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBluetooth"><Path d="M11.6614 12L16.9577 7.66667L10.4577 2.25V11.0152M11.6614 12L10.4577 12.9848M11.6614 12L16.9577 16.3333L10.4577 21.75V12.9848M11.6614 12L10.4577 11.0152M10.4577 12.9848L5.04102 17.4167M10.4577 12.9848V11.0152M10.4577 11.0152L5.04102 6.58333" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBluetooth;
